import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { resetListStyles } from '@hrworks/design-system/utilities';

import { generatePaddings } from './Entry/BaseItem/CollapsibleMenuBaseItem.styles';

const Container = styled.ul(({ theme }) => [
  resetListStyles,
  generatePaddings({
    theme,
  }),
  {
    '--collapsible-menu-depth-indicator-color': theme.eclipseTier2Color.border.bold,
    padding: `0 ${theme.eclipseTier1.spacing['8px']} ${theme.eclipseTier1.spacing['8px']} ${theme.eclipseTier1.spacing['8px']}`,
  },
]);

const components = { Container };

export const S = {
  ...components,
  ...createClassNames('ControlledCollapsibleMenu', components),
} as const;
